import React from "react";

import homeBack1 from "../images/homeBack1.jpg";
import rendgen from "../images/rendgen.jpg";
import home_background from "../images/home_background.png";
import CarouselComponent from "./CarouselComponent";

function Home() {
  const slides = [
    {
      image: homeBack1,
      description: `Стоматолошка ординација со повеќе од ${new Date().getFullYear() - 1998} години искуство!`,
    },
    {
      image: rendgen,
    },
    {
      image: home_background,
      description: "Нудиме најквалитетни стоматолошки услуги!",
    },
  ];

  return (
      <CarouselComponent slides={slides} />
  );
}

export default Home;
